import { WapSignScreen } from './WapSignScreen.tsx';
import { WapMeetScreen } from './WapMeetScreen.tsx';
import { WapStatScreen } from './WapStatScreen.tsx';
import { WapProScreen } from './WapProScreen.tsx';

/**
 * Faithful static replicas of each product's real app screen, keyed by product.
 * Each screen carries its OWN language, direction and palette (English/LTR for
 * WapSign & WapStat, Dhivehi/RTL for WapMeet & WapPro) so it renders correctly
 * inside the RTL landing page.
 */
export const SCREENS: Record<string, () => JSX.Element> = {
  wapsign: WapSignScreen,
  wapmeet: WapMeetScreen,
  wapstat: WapStatScreen,
  wappro: WapProScreen,
};
